import {
  QuestionMarkIcon_default
} from "./chunk-MSQHTP77.js";
import {
  muiMergeSx
} from "./chunk-F3QHBCNP.js";

// src/HelperButton.tsx
import { lazyLoad } from "@levana/utils/lazyLoad";
import { useModal } from "@levana/utils/modal";
import IconButton from "@mui/joy/IconButton";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var HelperButton = forwardRef(
  (props, ref) => {
    const { modal, onClick, sx, ...joyProps } = props;
    const { present } = useModal();
    return /* @__PURE__ */ jsx(
      IconButton,
      {
        color: "neutral",
        variant: "soft",
        "aria-label": "help",
        ...joyProps,
        ref,
        onClick: async (event) => {
          onClick?.(event);
          if (modal) {
            const HelperModal = await lazyLoad(() => import("./HelperModal.js"));
            present(/* @__PURE__ */ jsx(HelperModal, { title: modal.title, message: modal.message }));
          }
        },
        sx: [
          {
            "--IconButton-size": "1rem",
            "--Icon-fontSize": "calc(var(--IconButton-size) / 1.2)",
            color: "text.secondary",
            paddingInline: 0
          },
          (theme) => muiMergeSx(theme, sx)
        ],
        children: /* @__PURE__ */ jsx(QuestionMarkIcon_default, {})
      }
    );
  }
);
var HelperButton_default = HelperButton;

export {
  HelperButton_default
};
